export const MODAL_PREFERENCES_KEYS = {
    INCREASE_EXCEED_AMZ_ADS_CURR_BUDGET: 'INCREASE_EXCEED_AMZ_ADS_CURR_BUDGET',
    TOGGLE_ACTIVE_STATUS_OF_PRODUCT_AD: 'TOGGLE_ACTIVE_STATUS_OF_PRODUCT_AD',
    BULK_UPDATE_PRODUCT_ADS: 'BULK_UPDATE_PRODUCT_ADS',
}